const ALLOWED_SCHEMES = ["https:"];
const IMAGE_EXTENSIONS = [".jpg", ".jpeg", ".png", ".webp", ".gif", ".svg"];

interface ImageUrlValidationResult {
  valid: boolean;
  error?: string;
}

export function validateImageUrl(value: string): ImageUrlValidationResult {
  const trimmed = value.trim();
  if (!trimmed) {
    return { valid: false, error: "Image URL is required." };
  }

  if (trimmed.startsWith("/")) {
    return { valid: true };
  }

  let parsed: URL;
  try {
    parsed = new URL(trimmed);
  } catch {
    return { valid: false, error: "Enter a valid URL (https://...)." };
  }

  if (!ALLOWED_SCHEMES.includes(parsed.protocol)) {
    return {
      valid: false,
      error: "Image URL must use https://.",
    };
  }

  const pathname = parsed.pathname.toLowerCase();
  const hasImageExt = IMAGE_EXTENSIONS.some((ext) => pathname.endsWith(ext));
  if (!hasImageExt) {
    return {
      valid: false,
      error: "URL must point to an image (.jpg, .jpeg, .png, .webp, .gif, .svg).",
    };
  }

  return { valid: true };
}

export const IMAGE_URL_HINT =
  "Paste an https:// URL ending in .jpg, .png, .webp, .gif, or .svg.";
